import React, {useCallback} from 'react';
import { List } from 'antd';
import { PropertyFull } from '../../types';
import PropertyItem from "./PropertyItem";

export interface PropertyListProps {
    properties: PropertyFull[];
    selectedProperty?: PropertyFull;
    /**
     * Функция, которая для каждого свойства и его флага isSelected возвращает массив действий (ReactNode[]).
     */
    actions: (property: PropertyFull, isSelected: boolean) => React.ReactNode[];
}

const PropertyList: React.FC<PropertyListProps> = ({
                                                       properties,
                                                       selectedProperty,
                                                       actions,
                                                   }) => {

    const renderPropertyItem = useCallback((item: PropertyFull) => {
        const isSelected = selectedProperty?.id === item.id;
        const computedActions = actions(item, isSelected);
        return <PropertyItem key={item.id} property={item} actions={computedActions} />;
    }, [selectedProperty, actions]);

    return (
        <List<PropertyFull>
            dataSource={properties}
            renderItem={renderPropertyItem}
        />
    );
};

export default React.memo(PropertyList);
